var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.662,
    height: 85.274,
    viewBox: "0 0 89.662 85.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(0.857 0.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M44.832,70.143,17.788,84.36l5.165-30.113L1.075,32.921,31.31,28.528,44.832,1.13l13.521,27.4,30.235,4.393L66.71,54.247,71.875,84.36Z",
    transform: "translate(-0.857 -0.905)",
    fill: "#ffdc4e",
    stroke: "#ffdc4e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M395.419,181.815l13.407,27.166.047.1.105.015,29.98,4.356-21.693,21.146-.076.074.018.1,5.121,29.858-26.815-14.1-.094-.05-.094.05-26.815,14.1,5.121-29.858.018-.1-.076-.074L351.88,213.448l29.98-4.357.105-.015.047-.1,13.407-27.166m0-.457L381.83,208.892l-30.385,4.415,21.987,21.431L368.242,265l27.177-14.288L422.6,265l-5.19-30.263,21.987-21.431-30.385-4.416-13.589-27.534Z",
    transform: "translate(-351.445 -181.362)",
    fill: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.06c2f2d7.svg";
export { ForwardRef as ReactComponent };